// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\ndiv h6[data-v-1f7b47ee] {\n  color: var(--dark-green-50, #809795);\n  font-size: 0.9rem !important;\n  font-weight: 400;\n}\ndiv h6 strong[data-v-1f7b47ee] {\n  font-weight: 600;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
